import React, { useContext, useEffect, useState } from "react";
import crownGolden from "../../images/crown_golden.png";
import Swal from "sweetalert2";
import { ListDetailsContext } from "../../contexts/ListDetailsContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ProjectExpertIsVip({ isVip, expert_id }) {
  const { tableData, setTableData } = useContext(ListDetailsContext);
  const [isVipPopup, setIsVipPopup] = useState(false);
  const [isVipGolden, setIsVipGolden] = useState("");
  const { API_URL } = useContext(UrlContext);

  useEffect(() => {
    if (isVip === "yes") {
      setIsVipGolden("yes");
    } else {
      setIsVipGolden("no");
    }
  }, [isVip]);

  const handleIsVip = () => {
    const url = `${API_URL}save-expert-vip`;
    const data = {
      expertID: expert_id,
      isVip: isVipGolden === "yes" ? "no" : "yes",
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setIsVipPopup(false);
          if (isVipGolden === "yes") {
            setIsVipGolden("no");
          } else {
            setIsVipGolden("yes");
          }
          Swal.fire({
            icon: "success",
            title: "Success",
            showConfirmButton: false,
            timer: 1500,
          });
          setTableData(
            tableData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.isVip = isVipGolden === "yes" ? "no" : "yes";
              }
              return item;
            })
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  return (
    <>
      {isVipGolden === "yes" ? (
        <button
          className="pd-goldenCrownBtn"
          onClick={() => setIsVipPopup(true)}
        />
      ) : (
        <button className="pd-silverCrownBtn" onClick={() => handleIsVip()} />
      )}

      {isVipPopup && (
        <div className="prjdetails-removeVIP-popup-wrapper">
          <div className="tab-pane fade show prjdetails-removeVIP-div">
            <div>
              <center>
                <img src={crownGolden} width="50px" alt="" />
                <p>
                  Remove this expert from <strong>Top Consultants</strong> list?
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn btn-light"
                  onClick={() => setIsVipPopup(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={() => handleIsVip()}
                >
                  Continue
                </button>
              </center>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
